(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-creator-showcase-category-v1"]) return;
  try {
    
(function(){
  var root=document.getElementById('mmg-creator-showcase-category-v1');
  if(!root)return;
  var carousel=root.querySelector('[data-csc-carousel]');
  var slides=Array.prototype.slice.call(root.querySelectorAll('[data-csc-slide]'));
  var prev=root.querySelector('[data-csc-prev]');
  var next=root.querySelector('[data-csc-next]');
  var position=root.querySelector('[data-csc-position]');
  if(!carousel||!slides.length)return;

  function slideLeft(slide){
    return Math.max(0,slide.offsetLeft-carousel.offsetLeft);
  }

  function nearestIndex(){
    var left=carousel.scrollLeft;
    var best=0;
    var distance=Infinity;
    slides.forEach(function(slide,index){
      var d=Math.abs(slideLeft(slide)-left);
      if(d<distance){distance=d;best=index;}
    });
    return best;
  }

  function update(){
    var index=nearestIndex();
    if(position)position.textContent=(index+1)+' / '+slides.length;
    if(prev)prev.disabled=index===0;
    if(next)next.disabled=index===slides.length-1;
  }

  function move(direction){
    var index=nearestIndex();
    var target=Math.max(0,Math.min(slides.length-1,index+direction));
    carousel.scrollTo({left:slideLeft(slides[target]),behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches?'auto':'smooth'});
  }

  if(prev)prev.addEventListener('click',function(){move(-1);});
  if(next)next.addEventListener('click',function(){move(1);});
  carousel.addEventListener('scroll',function(){window.requestAnimationFrame(update);},{passive:true});

  var selected=root.querySelector('[data-selected="true"]');
  if(selected){
    window.requestAnimationFrame(function(){
      carousel.scrollLeft=slideLeft(selected);
      update();
    });
  }else{update();}
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["mmg-showcase-hub-cards-v1"]) return;
  try {
    
(function(){
  var hub=document.getElementById('mmg-showcase-hub-cards-v1');
  var proof=document.getElementById('mmg-web-kairos-live-proof-v1');
  var anchor=proof&&proof.querySelector('#wk-intelligence');
  if(hub&&anchor&&anchor.parentNode){anchor.parentNode.insertBefore(hub,anchor);}
})();

  } catch(e) { console.error(e); }
})();
})();
